var _circle, _circle2, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleCamers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2969,
    cy: 18,
    r: 18,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2969,
    cy: 18,
    r: 17.5,
    stroke: "#9C4900",
    strokeOpacity: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_79487",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.79688,
    y: 4.5,
    width: 27,
    height: 27,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_79487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2969 24.1875C19.7031 24.1875 20.8986 23.6955 21.8834 22.7115C22.8674 21.7267 23.3594 20.5312 23.3594 19.125C23.3594 17.7188 22.8674 16.5233 21.8834 15.5385C20.8986 14.5545 19.7031 14.0625 18.2969 14.0625C16.8906 14.0625 15.6951 14.5545 14.7104 15.5385C13.7264 16.5233 13.2344 17.7188 13.2344 19.125C13.2344 20.5312 13.7264 21.7267 14.7104 22.7115C15.6951 23.6955 16.8906 24.1875 18.2969 24.1875ZM9.29688 28.125C8.67812 28.125 8.14863 27.9049 7.70838 27.4646C7.26738 27.0236 7.04688 26.4938 7.04688 25.875V12.375C7.04688 11.7562 7.26738 11.2267 7.70838 10.7865C8.14863 10.3455 8.67812 10.125 9.29688 10.125H12.8406L14.9219 7.875H21.6719L23.7531 10.125H27.2969C27.9156 10.125 28.4455 10.3455 28.8865 10.7865C29.3268 11.2267 29.5469 11.7562 29.5469 12.375V25.875C29.5469 26.4938 29.3268 27.0236 28.8865 27.4646C28.4455 27.9049 27.9156 28.125 27.2969 28.125H9.29688Z",
    fill: "#9C4900",
    fillOpacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCamers);
export default __webpack_public_path__ + "static/media/circleCamers.bc0d57b7c11d2f5c5143e31c6f040d85.svg";
export { ForwardRef as ReactComponent };